/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_IntroInputs */

const th_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รับการแจ้งเตือนเมื่อเกมที่คุณติดตามเริ่มแข่ง คะแนนเปลี่ยน หรือจบลง`)
};

const en_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get a notification when a game you follow tips off, changes score, or ends.`)
};

const ja_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォロー中の試合の開始・スコア変更・終了を通知します。`)
};

const zh_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当你关注的比赛开始、比分变化或结束时收到消息。`)
};

const es_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recibe un aviso cuando empiece, cambie el marcador o termine un partido que sigues.`)
};

const pt_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Receba um aviso quando um jogo que você segue começar, mudar de placar ou terminar.`)
};

const id_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapat kabar saat pertandingan yang Anda ikuti dimulai, skornya berubah, atau selesai.`)
};

const fr_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soyez prévenu quand un match que vous suivez commence, change de score ou se termine.`)
};

const tl_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mabalitaan kapag nagsimula ang larong sinusundan mo, nagbago ang iskor, o natapos ito.`)
};

const vi_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Được báo khi trận bạn theo dõi bắt đầu, tỉ số đổi, hoặc trận kết thúc.`)
};

const ko_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팔로우한 경기가 시작하거나, 점수가 바뀌거나, 끝날 때 알려드립니다.`)
};

const de_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lass dich benachrichtigen, wenn ein Spiel, dem du folgst, beginnt, sich das Ergebnis ändert oder es endet.`)
};

const ru_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получайте сообщения, когда матч, на который вы подписаны, начинается, меняет счёт или заканчивается.`)
};

const tr_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takip ettiğiniz bir maç başladığında, skor değiştiğinde ya da maç bittiğinde haber alın.`)
};

const it_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ricevi un avviso quando una partita che segui inizia, cambia punteggio o finisce.`)
};

const pl_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostaniesz wiadomość, gdy obserwowany mecz się zacznie, zmieni wynik albo skończy.`)
};

const uk_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отримуйте повідомлення, коли матч, за яким ви стежите, починається, змінює рахунок або завершується.`)
};

const hi_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जब आपका फ़ॉलो किया मैच शुरू हो, स्कोर बदले या समाप्त हो, तब जानकारी पाएँ।`)
};

const ar_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اعرف حين تبدأ مباراة تتابعها، أو تتغير نتيجتها، أو تنتهي.`)
};

const ms_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dapat berita apabila perlawanan yang anda ikuti bermula, mata berubah, atau ia tamat.`)
};

const bn_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনি যে খেলা অনুসরণ করেন তা শুরু হলে, স্কোর বদলালে বা শেষ হলে জানুন।`)
};

const zh_tw2_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`當你追蹤的比賽開始、比分變動或結束時收到消息。`)
};

const zh_hk2_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`當你追蹤的比賽開始、比分變動或結束時收到消息。`)
};

const ur_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جب آپ کا فالو کیا میچ شروع ہو، اسکور بدلے یا ختم ہو تو خبر پائیں۔`)
};

const fa_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وقتی بازی‌ای که دنبال می‌کنید آغاز شود، نتیجه‌اش تغییر کند یا پایان یابد خبردار شوید.`)
};

const sw_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pata habari mchezo unaoufuatilia unapoanza, matokeo yanapobadilika, au unapoisha.`)
};

const nl_notifications_intro = /** @type {(inputs: Notifications_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krijg bericht wanneer een wedstrijd die je volgt begint, van stand verandert of afgelopen is.`)
};

/**
* | output |
* | --- |
* | "Get a notification when a game you follow tips off, changes score, or ends." |
*
* @param {Notifications_IntroInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const notifications_intro = /** @type {((inputs?: Notifications_IntroInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_IntroInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_notifications_intro(inputs)
	if (locale === "ja") return ja_notifications_intro(inputs)
	if (locale === "zh") return zh_notifications_intro(inputs)
	if (locale === "es") return es_notifications_intro(inputs)
	if (locale === "pt") return pt_notifications_intro(inputs)
	if (locale === "id") return id_notifications_intro(inputs)
	if (locale === "fr") return fr_notifications_intro(inputs)
	if (locale === "tl") return tl_notifications_intro(inputs)
	if (locale === "vi") return vi_notifications_intro(inputs)
	if (locale === "ko") return ko_notifications_intro(inputs)
	if (locale === "de") return de_notifications_intro(inputs)
	if (locale === "ru") return ru_notifications_intro(inputs)
	if (locale === "tr") return tr_notifications_intro(inputs)
	if (locale === "it") return it_notifications_intro(inputs)
	if (locale === "pl") return pl_notifications_intro(inputs)
	if (locale === "uk") return uk_notifications_intro(inputs)
	if (locale === "hi") return hi_notifications_intro(inputs)
	if (locale === "ar") return ar_notifications_intro(inputs)
	if (locale === "ms") return ms_notifications_intro(inputs)
	if (locale === "bn") return bn_notifications_intro(inputs)
	if (locale === "zh-TW") return zh_tw2_notifications_intro(inputs)
	if (locale === "zh-HK") return zh_hk2_notifications_intro(inputs)
	if (locale === "ur") return ur_notifications_intro(inputs)
	if (locale === "fa") return fa_notifications_intro(inputs)
	if (locale === "sw") return sw_notifications_intro(inputs)
	if (locale === "nl") return nl_notifications_intro(inputs)
	return en_notifications_intro(inputs)
});